export const SkillsData = [
  {
    type: "Frontend",
    List: [
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>,
      },

      {
        name: "CSS3",
        icon: <i class="devicon-css3-plain colored"></i>,
      },

      {
        name: "JAVSCRIPT",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },

      {
        name: "React",
        icon: <i class="devicon-react-original colored"></i>,
      },

      {
        name: "Redux",
        icon: <i class="devicon-redux-original colored"></i>,
      },

      {
        name: "Material-UI",
        icon: <i class="devicon-materialui-plain colored"></i>,
      },

      {
        name: "TypeScript",
        icon: <i class="devicon-typescript-plain colored"></i>,
      },

    ],
  },

  {
    type: "Backend",
    List: [
      {
        name: "Expres.js",
        icon: <i class="devicon-express-original colored"></i>,
      },

      {
        name: "Node.js",
        icon: <i class="devicon-nodejs-plain colored"></i>,
      },

      {
        name: "mySQL",
        icon: <i class="devicon-mysql-plain colored"></i>,
      },

      {
        name: "MongoDB",
        icon: <i class="devicon-mongodb-plain colored"></i>,
      },
    ],
  },
];
